import { render, staticRenderFns } from "./wx-payment-add.vue?vue&type=template&id=1491c78e&scoped=true&"
import script from "./wx-payment-add.vue?vue&type=script&lang=js&"
export * from "./wx-payment-add.vue?vue&type=script&lang=js&"
import style0 from "./wx-payment-add.vue?vue&type=style&index=0&id=1491c78e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1491c78e",
  null
  
)

export default component.exports